import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/carre-vide.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/carre-tick.svg';
export default {
  name: 'MdmCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    name: function name() {
      return this.value ? 'carre-tick' : 'carre-vide';
    }
  }
};